/**
 * 视频监控组件
 */

import {Style} from '@/libs/style.js';

let template = /*html*/ `<div class="video-monitoring">
    <div class="video-monitoring-header">
        <img src="./images/default/2.png" alt="">
        <h2>视频监控</h2>
        <dv-decoration-1 style="width:200px;height:100%;position:absolute;right:0;" />
    </div>
    <div class="video-monitoring-inside-container">
        <img src="./images/default/video-img.jpg" class="video-content"/>
        <!--<video height="250" width="300"src="./images/default/video.mp4" autoplay="autoplay" class="video-content" loop="loop"></video>-->
    </div>
</div>`;


let style = /* css */ `.video-monitoring{
    position: absolute;
    top: 0%;
    right: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 30%;
    overflow: hidden;
    
}

.video-monitoring .video-monitoring-header{
    background:linear-gradient(to right,#159AFF80,rgba(0,0,0,0) 100%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
    position:relative;
}
.video-monitoring .video-monitoring-header img{
    margin:0 15px;
}
.video-monitoring .video-monitoring-inside-container{
    padding:10px;
    box-sizing:border-box;
}
.video-monitoring .video-content{
    width:100%;
    height:100%;
}
`;

export default (Vue) => {
    Vue.customElement('xbt-video-monitoring', {
        template: template,
        data() {
            return {
               
            }
        },
        mounted() {
            Style(style);
        }
    });
}